var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button } from '@one-thd/sui-atomic-components';
import React from 'react';
import { Returns } from '@one-thd/sui-icons';
import { redirectToSignInWithCustomRedirect } from '../../../../utils/http-helper';
import { FeatureSwitches } from '../../../../constants/feature-switches';
import '../../../../styles/order-details.scss';
import { TagStartAReturn } from '../../../../utils/analytics';
import { isCookieEnabled } from '../../../../utils/cookie-helper';
import { getWindow, routeBuilder } from '../../../../utils/general';
import { buildOrderDetailsV2SessionObj, getMilitaryExchange, } from '../../../../utils/returns/returns-helper';
import { usePhase0BarcodeContext } from '../../../../hooks/useContexts';
export var StartAReturn = function (_a) {
    var buttonVariant = _a.buttonVariant, orderId = _a.orderId, tenders = _a.tenders, orderDetailsData = _a.orderDetailsData, isGuest = _a.isGuest, icon = _a.icon;
    var orderBarcodeApiState = usePhase0BarcodeContext().orderBarcodeApiState;
    var useClipboardFlow = isCookieEnabled('useClipboard');
    var onSARClick = function () {
        // If non military guest order, redirect to sign in page for authentication with order details URL built due to the user coming from guest tracker page
        if (isGuest && !getMilitaryExchange(orderDetailsData)) {
            var orderDetailsUrl = "/myaccount/order-details".concat(routeBuilder({
                orderNumber: orderId,
                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                orderOrigin: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin,
                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                nickName: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.nickName,
            }));
            redirectToSignInWithCustomRedirect(orderDetailsUrl);
        }
        else
            onStartReturn();
    };
    var onStartReturn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var orderDetailsDataV2, orderDetailsJsonString;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    orderDetailsDataV2 = buildOrderDetailsV2SessionObj(orderDetailsData, Boolean(FeatureSwitches.allowSTHUndeliveredReturns));
                    orderDetailsJsonString = JSON.stringify([
                        {
                            orderId: orderId,
                            tenders: tenders,
                            orderDetailsDataV2: orderDetailsDataV2,
                            isGuest: isGuest,
                            xAuthGuestToken: orderDetailsData.xAuthGuestToken,
                            militaryExchange: getMilitaryExchange(orderDetailsData),
                            orderBarcode: (_a = orderBarcodeApiState === null || orderBarcodeApiState === void 0 ? void 0 : orderBarcodeApiState.data) === null || _a === void 0 ? void 0 : _a.barcodeImg,
                        },
                    ]);
                    (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.setItem('orderDetailsData', orderDetailsJsonString);
                    if (!useClipboardFlow) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.clipboard
                            .writeText(orderDetailsJsonString)
                            .then(function () {
                            if (getWindow()) {
                                window.location.href = "https://localhost.".concat(window.location.hostname, ":3001/myaccount/start-a-return");
                            }
                        })
                            .catch(function (err) {
                            // eslint-disable-next-line no-console
                            return console.error('Error copying orderDetails to clipboard', err);
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    // Analytics
                    TagStartAReturn(orderDetailsData);
                    if (getWindow()) {
                        window.location.href = '/myaccount/start-a-return';
                    }
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "card-fix", "data-testid": "sar-button" },
        React.createElement(Button, { variant: buttonVariant, onClick: onSARClick },
            React.createElement("div", { className: "sui-flex sui-gap-2 sui-items-center" },
                icon && React.createElement(Returns, { size: "small" }),
                "Start a Return"))));
};
